module.exports = __webpack_public_path__ + "img/defaultback.3b66661d.png";